export type OrderPriceOrigin = 'india' | 'other-than-india' | 'saarc';

export function formatInr(amount: number): string {
  return `₹${Math.round(amount).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
}

/** Other than India checkout uses USD; India and SAARC stay in rupees. */
export function formatOrderMoney(
  amount: number,
  origin?: OrderPriceOrigin | string | null,
): string {
  if (origin === 'other-than-india') {
    return `$${Math.round(amount).toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
  }
  return formatInr(amount);
}

export function priceOriginLabel(origin?: OrderPriceOrigin | string | null): string {
  if (origin === 'other-than-india') return 'Other than India ($)';
  if (origin === 'saarc') return 'SAARC Nation (₹)';
  return 'India (₹)';
}

export function formatReportInr(value?: number | null): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '—';
  return formatInr(value);
}

export function formatReportPercent(value?: number | null, digits = 1): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '—';
  return `${value.toFixed(digits)}%`;
}

export function formatReportDecimal(value?: number | null, digits = 1): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '—';
  return value.toFixed(digits);
}
